import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AppliaSecretariatProps } from "./AppliaSecretariat.type";
import { StaffMember } from "./StaffMember/StaffMember";

const AppliaSecretariat: FC<AppliaSecretariatProps> = ({ members }) => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-14">
			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10">
				{members.map((member) => (
					<StaffMember
						key={member.name}
						name={member.name}
						imageUrl={member.imageUrl}
						background={t(member.background)}
						functionTitle={t(member.functionTitle)}
						toggleText={t("pages.introduction.appliaSecretariat.background")}
					/>
				))}
			</div>
			<hr className="border-dotted border-t-4" />
		</div>
	);
};

export { AppliaSecretariat };
